import { useQuery } from "react-query";
import { MigrationSetWithImports, useSmokeballApp } from "../shared";
import log from "../shared/utils/log";
import { requestHelper } from "../shared/utils";

const fetchExistingMigrations = async ({
  accountId,
  token,
}: {
  accountId: string;
  token?: () => Promise<string>;
}): Promise<MigrationSetWithImports[]> => {
  const endpoint = ``;
  const data = await requestHelper(
    accountId,
    endpoint,
    "Failed to list imports.",
    "GET",    
    token,
  );
  log("JSON data of reponse to fetch existing import: ", data);

  return data;
};

export const useExistingMigrations = () => {
  const { auth, context } = useSmokeballApp();
  const accountId = context?.firmId || "";
  const token = auth?.token;

  if (!token) {
    throw new Error("Authentication token function is missing.");
  }

  const { data, isLoading } = useQuery({
    queryKey: ["migrations", accountId],
    queryFn: () => fetchExistingMigrations({ accountId, token }),
    refetchInterval: 10000,
    enabled: !!accountId,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
  };
};
